import { render, staticRenderFns } from "./CardItemLink.vue?vue&type=template&id=65122ddc&"
import script from "./CardItemLink.vue?vue&type=script&lang=js&"
export * from "./CardItemLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports